import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { routes } from 'routes/routes';

/**
 * @deprecated
 * Should be in pages folder/hooks when old program pages will move to pages component
 */
export const useOnLeaveProgram = () => {
  const navigate = useNavigate();

  return useCallback(async () => navigate(routes.program.index), [navigate]);
};
